<template>
    <div class="w-full min-h-screen flex bg-gray-100 dark:bg-gray-900">
        <sidebar></sidebar>

        <div class="w-full overflow-hidden focus:outline-none pt-16 lg:pt-0" tabindex="0">
            <!-- Page Content -->
            <slot></slot>
        </div>

        <!-- Modal Portal -->
        <portal-target name="modal" multiple>
        </portal-target>
        <!-- Other Portal -->
        <portal-target name="general" multiple>
        </portal-target>
    </div>
</template>

<script>
import Sidebar from '@/Components/Layout/Sidebar';

export default {
    components: {
        Sidebar,
    },

    props: {
        user: Object,
    },

    metaInfo: {
        // all titles will be injected into this template
        titleTemplate: titleChunk => {
            if (titleChunk) {
                return titleChunk + ' | Storemanager';
            }

            return 'Storemanager';
        },
    },

    data() {
        return {
            showingNavigationDropdown: false,
        };
    },
};
</script>
